import script from "./list-empty.vue?vue&type=script&setup=true&lang=js"
export * from "./list-empty.vue?vue&type=script&setup=true&lang=js"

import "./list-empty.vue?vue&type=style&index=0&id=2b5c35be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b5c35be"]])

export default __exports__